import { useMapEvents } from "react-leaflet";
import { useEffect, useState } from "react";
import {
  setSrcAddress,
  setSrcAddressRoute,
  setSrcBuilding,
} from "store/slices/srcAddress";
import { useGetNearestGeoDataQuery } from "store/api";
import { useAppDispatch } from "store/hooks/useAppDispatch";
import { useAppSelector } from "store/hooks/useAppSelector";
import { setAddress, setBuilding } from "store/slices/dstAddress";
import { shallowEqual } from "react-redux";
import { initialPoint } from "./constants";
import { ILocation } from "./types";

const MapClickHandler = () => {
  const [startPoint, setStartPoint] = useState<ILocation>(initialPoint);
  const [dstPoint, setDstPoint] = useState<ILocation>(initialPoint);
  const dispatch = useAppDispatch();
  const srcAddress = useAppSelector(
    (state) => state.srcAddress.srcAddressRoute,
    shallowEqual,
  );
  const dstBoxes = useAppSelector(
    (state) => state.dstAddress.boxes,
    shallowEqual,
  );

  const { data: startPointData, isSuccess: isStartPointSuccess } =
    useGetNearestGeoDataQuery(
      {
        lat: startPoint.lat,
        lng: startPoint.lng,
      },
      {
        skip: !startPoint.lat,
      },
    );

  const { data: dstPointData, isSuccess: isDstPointSuccess } =
    useGetNearestGeoDataQuery(
      {
        lat: dstPoint.lat,
        lng: dstPoint.lng,
      },
      {
        skip: !dstPoint.lat,
      },
    );

  useEffect(() => {
    if (isStartPointSuccess && startPointData) {
      if (startPointData.geo_objects.geo_object.length) {
        const startObject = startPointData.geo_objects.geo_object[0];
        dispatch(
          setSrcAddress({
            name: startObject.name,
          }),
        );
        dispatch(
          setSrcAddressRoute({
            name: startObject.name,
            lat: startObject.lat,
            lng: startObject.lng,
          }),
        );
      }
      if (startPointData.geo_streets.geo_street.length) {
        const startAddress = startPointData.geo_streets.geo_street[0];
        dispatch(
          setSrcAddress({
            name: startAddress.name,
          }),
        );
        dispatch(
          setSrcBuilding({
            house: startAddress.houses[0].house,
          }),
        );
        dispatch(
          setSrcAddressRoute({
            name: startAddress.name,
            number: startAddress.houses[0].house,
            lat: startAddress.houses[0].lat,
            lng: startAddress.houses[0].lng,
          }),
        );
      }
    }
  }, [startPointData, isStartPointSuccess]);

  useEffect(() => {
    if (isDstPointSuccess && dstPointData) {
      const boxIndex =
        dstBoxes.length === 1 ? 0 : dstBoxes.length === 2 ? 1 : 2;
      if (dstPointData.geo_objects.geo_object.length) {
        const dstObject = dstPointData.geo_objects.geo_object[0];
        dispatch(
          setAddress({
            currentInput: boxIndex,
            address: dstObject.name,
            foundBuildings: [],
            lat: dstObject.lat,
            lng: dstObject.lng,
          }),
        );
      }
      if (dstPointData.geo_streets.geo_street.length) {
        const dstAddress = dstPointData.geo_streets.geo_street[0];
        dispatch(
          setAddress({
            currentInput: boxIndex,
            address: dstAddress.name,
            foundBuildings: dstAddress.houses,
          }),
        );
        dispatch(
          setBuilding({
            currentInput: boxIndex,
            building: dstAddress.houses[0].house,
            lat: dstAddress.houses[0].lat,
            lng: dstAddress.houses[0].lng,
          }),
        );
      }
    }
  }, [dstPointData, isDstPointSuccess]);

  useMapEvents({
    click(e) {
      const { lat, lng } = e.latlng;
      if (!srcAddress.lat) {
        setStartPoint({ lat, lng });
      } else {
        setDstPoint({ lat, lng });
      }
    },
  });
  return null;
};

export default MapClickHandler;
